import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import {
  PrintersApiAdapter,
  PrintersSettingsModel,
} from '../adapters/PrintersApiAdapter';
import { useToast } from '@shared/hooks/use-toast';

export const useUpdatePrintersSettings = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new PrintersApiAdapter(httpClient);

  const {
    mutate: updateSettings,
    isPending: isUpdating,
    error,
  } = useMutation({
    mutationFn: (settings: Partial<PrintersSettingsModel>) =>
      apiAdapter.updateSettings(settings),
    onSuccess: (data) => {
      // Actualizar el cache con los nuevos datos
      queryClient.setQueryData(['printersSettings'], data);

      // Invalidar la query para refrescar los datos
      queryClient.invalidateQueries({ queryKey: ['printersSettings'] });

      toast({
        title: 'Configuración actualizada',
        description:
          'La configuración de impresoras se actualizó correctamente.',
        variant: 'default',
      });
    },
    onError: (error: any) => {
      console.error('🔍 useUpdatePrintersSettings - Error:', {
        message: error.message,
        response: error.response,
      });

      toast({
        title: 'Error al actualizar',
        description: 'No se pudo actualizar la configuración de impresoras.',
        variant: 'destructive',
      });
    },
  });

  return {
    updateSettings,
    isUpdating,
    error: error?.message || null,
  };
};
